import React, { useEffect, useState } from "react";
import {
    useStripe,
    useElements,
    PaymentElement,
    Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { baseUrl, shopBaseUrl } from "utils/helper_functions";

const stripePromise = (pk) => loadStripe(pk, { locale: "ro" });

const StripeForm = ({
    general_color,
    inner_text_color,
    close_dialog,
    setLoader,
    id_delivery,
}) => {
    const stripe = useStripe();
    const elements = useElements();
    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();
        setLoader(true);

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            setLoader(false);
            return;
        }
        const { error, result } = await stripe.confirmPayment({
            //`Elements` instance that was used to create the Payment Element
            elements,
            confirmParams: {
                return_url: shopBaseUrl() + (id_delivery ? `?id_delivery=${id_delivery}` : ""),
            },
        });

        if (error) {
            // This point will only be reached if there is an immediate error when
            // confirming the payment. Show error to your customer (e.g., payment
            // details incomplete)
            setLoader(false);
            setErrorMessage(error.message);
        } else {
            setLoader(true);
        }
    };

    return (
        <div
            style={{ borderColor: general_color }}
            className="payment_conf_modal_container"
        >
            <form onSubmit={handleSubmit}>
                <div className="popup_paragraf_title">
                    <div>Plată online</div>
                    <img className="powered_by_stripe" src={baseUrl("uploads/venues/powered_by_stripe.png")} />
                </div>
                <div className="popup_paragraf" style={{ color: general_color }}>
                    <PaymentElement
                        onChange={() => { if (errorMessage) setErrorMessage(null) }}
                    />
                </div>
                {errorMessage && <div className="error-message">{errorMessage}</div>}
                <div className={"btn_container____"}>
                    <div
                        style={{
                            color: general_color,
                            backgroundColor: "white",
                            textAlign: "center",
                        }}
                        className={"sub_btn____"}
                        onClick={close_dialog}
                    >
                        <a style={{ color: general_color }}>ANULEAZĂ</a>
                    </div>
                    <button
                        type="submit"
                        disabled={!stripe}
                        style={{
                            backgroundColor: general_color,
                            textAlign: "center",
                        }}
                        className={"sub_btn____"}
                    >
                        <a style={{ color: inner_text_color }}>PLĂTEȘTE</a>
                    </button>
                </div>
            </form >
        </div>
    );
};

const OnlinePayment = (props) => {
    const { general_color, close_dialog, inner_text_color, stripe_pk, options, setLoader, id_delivery } = props;

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setTimeout(() => {
            setLoader(false);
        }, 2000)
    }, []);

    return (
        <Elements stripe={stripePromise(stripe_pk)} options={options}>
            <StripeForm
                general_color={general_color}
                inner_text_color={inner_text_color}
                close_dialog={close_dialog}
                setLoader={setLoader}
                id_delivery={id_delivery}
            />
        </Elements>
    );
};

export default OnlinePayment;
